//react
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';

//components
import AdditionalPageContent from '../../components/additionalPageContent/additionalPageContent';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import NavContent from '../../components/navContent/navContent';
import PageRequestContent from '../../components/pageRequestContent/pageRequestContent';
import PageRequestValidator from '../../components/pageRequestValidator/pageRequestValidator';
import PopupUserTypeConfirmation from '../../components/popup/userTypeConfirmation';

//data
import dataSiteMap from '../../siteMap.json';

//assets
import './contentPage.css';

//functions
import * as Utilities from '../../utilities';

class CultureSelect extends Component {
	componentDidMount() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	render() {
		const culture = this.props.match.params.culture;
		const section = this.props.match.params.section;
		let page = this.props.match.params.page;

		if (!page) {
			try {
				page = dataSiteMap[culture].navigation[section].pages.filter(({live}) => live === true)[0].key;

				return (
					<Redirect to={'/' + culture + '/' + section + '/' + page} />
				);
			} catch (error) {
				console.log('No matched content within this page');
			}
		}

		Utilities.setLanguage(culture);
		Utilities.setAlternatePageLinks(culture, section, page);

		return (
			<div className="wrapper">

				<PageRequestValidator culture={culture} page={page} section={section} />

				<DocumentMeta {...Utilities.getMeta(culture, section, page)} />

				<Header contentPage={true} culture={culture} />

				<section className="content-page">
					<div className="container">
						<div className="container__row">
							<div className="container__column container__column--third container__column--top">
								<NavContent culture={culture} page={page} section={section} />
							</div>
							<div className="container__column container__column--top">

								<PageRequestContent culture={culture} page={page} section={section} />

								<AdditionalPageContent culture={culture} page={page} section={section} />
							</div>
						</div>
					</div>
				</section>

				<Footer contentPage={true} culture={culture} section={section} />

				<PopupUserTypeConfirmation culture={culture} page={page} section={section} />

			</div>
		);
	}
}

export default CultureSelect;



// WEBPACK FOOTER //
// ./src/pages/contentPage/contentPage.js